var path = 'features/referral/templates/partials/error.html';
var html = "<script type=\"text/ng-template\" id=\"hmrErrorModal.html\">\n    <div class=\"modal-header\">\n        <button ng-click=\"HmrErrorCtrl.cancel()\" class=\"close\">\n            <span class=\"icon icon-cross\"></span>\n        </button>\n        <h2 class=\"modal-title main-title\">An error occurred</h2>\n    </div>\n    <div class=\"modal-body\">\n        <p>{{HmrErrorCtrl.message}}</p>\n    </div>\n</script>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/features/referral/templates/partials/error.html
 ** module id = 129
 ** module chunks = 0
 **/